import { Component } from '@angular/core';
import { SplashScreenComponent } from "../../shared/components/splash-screen/splash-screen.component";

@Component({
    selector: 'app-auth-callback',
    template: `<app-splash-screen>`,
    imports: [SplashScreenComponent]
})
export class AuthCallbackComponent {
  constructor() {}
}
